import angular from 'angular'

import { $timeout } from '../../ng-compat/imports'
import { EVENT } from '../../constants'
import { SaleManager } from '../../managers/sale-manager'

/**
 * Scrolls the saleslist container when a new line item is added
 *
 * @module webregister.directives.wrSaleListScroll
 *
 */
angular
  .module('webregister.directives')
  .directive('wrSaleListScroll', function () {
    return {
      restrict: 'A',
      /**
       * =======================================
       * SALELIST SCROLL CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe, saleManager: SaleManager, $scope) {
        /**
         * Scroll container: sets the elements scrollTop to position the scroll position to the last line item before
         * the sale list footer.
         *
         * @private
         * @method _scrollContainer
         */
        this._scrollContainer = function () {
          $timeout(() => {
            const lastLineItem = document.querySelector(
              '.sale-list .sale-list-item:last-child'
            )

            lastLineItem && lastLineItem.scrollIntoView(false)
          })
        }

        saleManager.on(EVENT.SALE_ADD_LINE_ITEM, this._scrollContainer)
        saleManager.on(EVENT.SALE_ADD_UNKNOWN_LINE_ITEM, this._scrollContainer)

        $scope.$on('$destroy', () => {
          saleManager.off(EVENT.SALE_ADD_LINE_ITEM, this._scrollContainer)
          saleManager.off(
            EVENT.SALE_ADD_UNKNOWN_LINE_ITEM,
            this._scrollContainer
          )
        })
      },
    }
  })
